export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Good morning"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Good afternoon"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Good evening"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Good night"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
}